<template>
	<div class="sidebar-cart__details">
		<table class="sidebar-cart__details-table">
			<thead class="sidebar-cart__details-table-head">
				<tr class="sidebar-cart__details-table-row">
					<th
						class="sidebar-cart__details-table-header"
					/>
					<th
						class="sidebar-cart__details-table-header"
						v-html="$t('cart.details.calories')"
					/>
					<th
						class="sidebar-cart__details-table-header"
						v-html="$t('cart.details.co2')"
					/>
				</tr>
			</thead>
			<tbody class="sidebar-cart__details-table-body">
				<tr
					class="sidebar-cart__details-table-row"
					v-for="item in items"
					:key="`details-item-${item.id}`"
				>
					<td
						class="sidebar-cart__details-table-cell"
					>
							<span
								class="sidebar-cart__details-name"
								v-html="item.name"
							/>
							<span
								class="sidebar-cart__details-meta"
								v-if="item.variant"
								v-html="item.variant"
							/>
					</td>
					<td
						class="sidebar-cart__details-table-cell"
						v-html="item.nutrient.calories"
					/>
					<td
						class="sidebar-cart__details-table-cell"
						v-html="item.co2.emission"
					/>
				</tr>
				<tr
					v-if="hasFeature('FEATURE_ADDITIONALPRODUCTS') && additionalItemsAvailable && totalItemsWithoutAdditional"
					class="sidebar-cart__details-table-row"
				>
					<td
						class="sidebar-cart__details-table-cell"
					>
							<span
								class="sidebar-cart__details-name"
								v-html="$t('cart.additionalProducts.title')"
							/>
					</td>
					<td
						class="sidebar-cart__details-table-cell"
						v-html="additionalItemsTotalNutrient.calories"
					/>
					<td
						class="sidebar-cart__details-table-cell"
						v-html="additionalItemsTotalCo2.emission"
					/>
				</tr>
			</tbody>
			<tfoot class="sidebar-cart__details-table-foot">
				<tr class="sidebar-cart__details-table-row">
					<td
						class="sidebar-cart__details-table-footer"
					>
							<span
								class="sidebar-cart__details-total"
								v-html="$t('cart.details.total')"
							/>
					</td>
					<td
						class="sidebar-cart__details-table-footer"
						v-html="totalNutrient.calories"
					/>
					<td
						class="sidebar-cart__details-table-footer"
						v-html="totalCo2.emission"
					/>
				</tr>
			</tfoot>
		</table>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('additionalproducts', [
			'items',
			'additionalItemsTotalCo2',
			'additionalItemsTotalNutrient',
			"additionalItemsAvailable",
		]),
		...mapGetters('cart', [
			"totalItemsWithoutAdditional",
			'totalCo2',
			'totalNutrient',
		]),
	}
}
</script>

<style>

</style>